const DATA_URL = /^data:([^;,]*)(;[^,]*)?,/;

/**
 * Splits a data URL into the bare base64 payload and its declared media type.
 *
 * The AI endpoints take `data` as bare base64 and pass it straight to the
 * model provider, so a value still carrying its `data:image/png;base64,`
 * prefix is rejected. Canvas exports (`toDataURL`) always carry that prefix
 * and their real encoding is PNG regardless of the source file's extension,
 * so the media type has to come from the URL rather than from the filename.
 *
 * Non-data-URL input passes through unchanged with a null mediaType, which
 * keeps callers that already hold bare base64 working.
 *
 * @param {string | null | undefined} dataUrl
 * @returns {{ data: string | null, mediaType: string | null }}
 */
export default function dataUrlToBase64(dataUrl) {
  if (!dataUrl) return { data: null, mediaType: null };

  const match = dataUrl.match(DATA_URL);
  if (!match) return { data: dataUrl, mediaType: null };

  return {
    data: dataUrl.slice(match[0].length),
    mediaType: match[1] || null,
  };
}
